/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_Downgrade_DescriptionInputs */



/**
* | output |
* | --- |
* | "Review what you will lose before confirming the downgrade." |
*
* @param {Plan_Tab_Downgrade_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_downgrade_description = /** @type {((inputs?: Plan_Tab_Downgrade_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Downgrade_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überprüfe, was du verlierst, bevor du das Downgrade bestätigst.")
	return /** @type {LocalizedString} */ ("Review what you will lose before confirming the downgrade.")
});